import { FormattedMessage, useIntl } from 'react-intl';

import { CardRichTextRenderer } from '@/components/Cms/Card/components/BaseCardType/RichTextEditor/CardRichTextRenderer';
import { SectionHeader } from '@/components/SectionHeader';
import { Typography } from '@/components/Typography';
import { BREITLING_ADDRESS, CONTACT_DETAILS } from '@/lib/const';
import { messages as boutiqueMessages } from '@/messages/boutique';
import { formMessages } from '@/messages/forms';

import * as S from '../ContactUs.styles';
import { messages } from '../messages';

interface ContactProps {
  bodyText?: any | null;
  handleCallBreitlingClick: (value: string) => void;
  header?: string | null;
  subheading?: string | null;
}

export const Contact: React.FC<ContactProps> = ({
  bodyText,
  handleCallBreitlingClick,
  header,
  subheading,
}) => {
  const { formatMessage } = useIntl();
  return (
    <S.Card>
      <SectionHeader
        colorized={false}
        data-test-id='ConfirmationViewSectionHeader'
        disableGutters
        sizeDesktop={32}
        sizeMobile={28}
        text={header ?? formatMessage(messages.contact)}
        textAlign='left'
      />
      <S.Section>
        <Typography
          fontFamily='italianPlate'
          mb='s025'
          scale='p0'
          textTransform='uppercase'
        >
          {subheading}
        </Typography>
        {bodyText && <CardRichTextRenderer text={bodyText} />}
      </S.Section>
      <S.Contact>
        <Typography fontWeight='bold' scale='p2' textTransform='uppercase'>
          {BREITLING_ADDRESS.company}
        </Typography>
        <Typography scale='p2' textTransform='uppercase'>
          {BREITLING_ADDRESS.street}
        </Typography>
        <Typography scale='p2' textTransform='uppercase'>
          {BREITLING_ADDRESS.city}
        </Typography>
        <S.Pointer>
          <Typography
            onClick={() =>
              handleCallBreitlingClick(CONTACT_DETAILS.DEFAULT!.contact_phone)
            }
            scale='p2'
          >
            <FormattedMessage
              {...formMessages.findYourClosestBoutique}
            ></FormattedMessage>{' '}
            <S.Underline>
              {CONTACT_DETAILS.DEFAULT?.contact_phone}
            </S.Underline>{' '}
          </Typography>
        </S.Pointer>
        <Typography scale='p2'>
          <FormattedMessage {...boutiqueMessages.fax}></FormattedMessage>{' '}
          <S.Underline>{CONTACT_DETAILS.DEFAULT?.contact_fax}</S.Underline>{' '}
        </Typography>
      </S.Contact>
    </S.Card>
  );
};
